import { SPORT_TYPES, type SportType } from "@/types/data.types";

export function isSportType(x: string): x is SportType {
  return (SPORT_TYPES as readonly string[]).includes(x);
}
